import prettyBytes from 'pretty-bytes';

export const CONTAINER_TYPE = {
  CONVERSATION: 'CONVERSATION',
  FOLDER: 'FOLDER',
};

export const ITEM_TYPE = {
  MESSAGE: 'MESSAGE',
  FILE: 'FILE',
};

export const POPUP_READY = 'POPUP_READY';
export const FILE_LIST = 'FILE_LIST';
export const ALL_UPLOADS_COMPLETE = 'ALL_UPLOADS_COMPLETE';
export const ALL_UPLOADS_ABORTED = 'ALL_UPLOADS_ABORTED';

export const FILE_SELECTED = 'FILE_SELECTED';
export const SELECTION_COMPLETE = 'SELECTION_COMPLETE';

const ONE_KB_IN_BYTES = 1000;
const ONE_MB_IN_BYTES = ONE_KB_IN_BYTES * 1000;
const ONE_GB_IN_BYTES = ONE_MB_IN_BYTES * 1000;

export const MAX_FILE_SIZE = ONE_GB_IN_BYTES * 20;
export const DAYS_TO_EXPIRY = 15;
export const MAX_FILE_SIZE_HUMAN_READABLE = prettyBytes(MAX_FILE_SIZE);

export const MAX_ACCESS_LINK_RETRIES = 5;
// We set the split size to 100 MB by default, but it can be overridden by an environment variable.
const SPLIT_SIZE_IN_MB: number = import.meta.env.VITE_SPLIT_SIZE_IN_MB || 100; // Default to 100 MB if not set
export const SPLIT_SIZE = SPLIT_SIZE_IN_MB * ONE_MB_IN_BYTES;

// Maximum number of parts of a multipart upload that are uploaded concurrently.
// Parts are run through a bounded pool (not fixed sequential batches), so a slow
// or failing part never blocks unrelated parts from starting.
// Tuned to 4: uploads are bandwidth-bound (aggregate throughput is flat from 2
// to 8 concurrent parts), so 4 keeps the pipe saturated without buffering more
// ciphertext in memory than necessary. See docs/UploadReliabilityOptimizations.md.
export const MAX_CONCURRENT_PARTS = 4;

// Cache durations
const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;
export const FIFTEEN_MINUTES = 15 * ONE_MINUTE_IN_MILLISECONDS; // 15 minutes in milliseconds

export const PING = 'TB/PING';
export const BRIDGE_PING = 'APP/PING';
export const BRIDGE_READY = 'TB/BRIDGE_READY';
export const OIDC_USER = 'TB/OIDC_USER';
export const OIDC_TOKEN = 'TB/OIDC_TOKEN';
export const OIDC_LOAD = 'TB/OIDC_LOAD';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_IN_COMPLETE = 'SIGN_IN_COMPLETE';
export const SEND_MESSAGE_TO_BRIDGE = 'SEND_MESSAGE_TO_BRIDGE';
export const TRANSFER_BRIDGE_MESSAGE = 'TRANSFER_BRIDGE_MESSAGE';
export const GET_LOGIN_STATE = 'GET_LOGIN_STATE';
export const LOGIN_STATE_RESPONSE = 'LOGIN_STATE_RESPONSE';
export const FORCE_CLOSE_WINDOW = 'FORCE_CLOSE_WINDOW';
export const OPEN_MANAGEMENT_PAGE = 'OPEN_MANAGEMENT_PAGE';

export const STORAGE_KEY_AUTH = 'STORAGE_KEY_AUTH';
export const PENDING_ADDON_TOKEN = 'tbpro-pending-addon-token';
export const GET_PENDING_ADDON_TOKEN = 'TB/GET_PENDING_ADDON_TOKEN';
export const PENDING_ADDON_TOKEN_RESPONSE = 'TB/PENDING_ADDON_TOKEN_RESPONSE';

// Telemetry pref bridge (issue #952). The hosted Send dashboard (send.js) runs
// as a web page without access to the `browser.thundermailTelemetry` experiment API, so it
// asks the background script for the Thunderbird telemetry pref via the
// token-bridge instead of reading it directly.
//   GET_TELEMETRY_STATE      : web page → bridge → background ("what's the pref?")
//   TELEMETRY_STATE_RESPONSE : background → bridge → web page ("{ enabled }")
//   TELEMETRY_STATE_CHANGED  : background → bridge → web page (runtime pref change)
export const GET_TELEMETRY_STATE = 'TB/GET_TELEMETRY_STATE';
export const TELEMETRY_STATE_RESPONSE = 'TB/TELEMETRY_STATE_RESPONSE';
export const TELEMETRY_STATE_CHANGED = 'TB/TELEMETRY_STATE_CHANGED';
